import { request } from '@/legacy/core/request'

import type { ContentReview } from '@/legacy/models'

import { sendError } from '../error'

export const postContentReview = async (payload: { url: string; rating: number }) => {
  try {
    const response = await request.post('/builder/api/submit-content-review/', payload)
    return response
  } catch (error) {
    sendError({ error })
    return error
  }
}

export const getContentReviewByUrl = async ({ url }: { url: string }) => {
  try {
    const { data } = await request.get<ContentReview>(`/builder/api/url-content-review`, {
      params: { url },
    })

    return data
  } catch (error) {
    sendError({ error })
    return null
  }
}
